/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SupportsShutdownRequest = {
  agentId: string;
};

/** @internal */
export const SupportsShutdownRequest$inboundSchema: z.ZodType<
  SupportsShutdownRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type SupportsShutdownRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const SupportsShutdownRequest$outboundSchema: z.ZodType<
  SupportsShutdownRequest$Outbound,
  z.ZodTypeDef,
  SupportsShutdownRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function supportsShutdownRequestToJSON(
  supportsShutdownRequest: SupportsShutdownRequest,
): string {
  return JSON.stringify(
    SupportsShutdownRequest$outboundSchema.parse(supportsShutdownRequest),
  );
}
export function supportsShutdownRequestFromJSON(
  jsonString: string,
): SafeParseResult<SupportsShutdownRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SupportsShutdownRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SupportsShutdownRequest' from JSON`,
  );
}
